import { NavController, NavParams, Events, LoadingController, AlertController, ModalController, ToastController, ActionSheetController } from 'ionic-angular';
import { Component } from '@angular/core';
import { AngularFire } from 'angularfire2';
import { Storage } from '@ionic/storage';
import { languagesPipe } from '../../pipes/languages';
import { AuthData } from '../../providers/auth';
import { UserData } from '../../providers/user';
import { Database } from '../../providers/database';
import { EventData } from '../../providers/event';
import { TranslateService } from '@ngx-translate/core';
import { Translate } from '../../providers/translate';
import { UserEditPage } from '../user-edit/user-edit';
import { LoginPage } from '../login/login';
import { EventFavoritePage } from '../event-favorite/event-favorite';
import { EventProfileReserves } from '../event-profile-reserves/event-profile-reserves';
import { EventOpinometerView } from '../event-opinometer-view/event-opinometer-view';
import { EventQuestionView } from '../event-question-view/event-question-view';
import { EventCatalogsPayment } from '../event-catalogs-payment/event-catalogs-payment';
import { EventCart } from '../event-cart/event-cart';

@Component({
  selector: 'page-event-profile',
  templateUrl: 'event-profile.html',
  providers: [languagesPipe]
})
export class EventProfilePage {

  obsBadgeCatalog: any;
  isAnonymous: boolean = null;
  event: any;
  user: any;
  client: any;
  textTranslate: any;
  isMultilanguages: any = false;
  badgeCatalogUser: any = [];

  constructor(public navCtrl: NavController, public params: NavParams, public af: AngularFire, public auth: AuthData, public events: Events, public storage: Storage, public userProvider: UserData, public loading: LoadingController, public alertCtrl: AlertController, translate: Translate, public translateProvider: TranslateService, public db: Database, public languages: languagesPipe, public eventProvider: EventData, public modalCtrl: ModalController, public toastCtrl: ToastController, public actionSheetCtrl: ActionSheetController) {
    translate.translateGroup(['Ok', 'Seleccione un idioma', 'Cancelar', 'Inglés', 'Español', 'Catalán', 'Cargando', 'Cerrando sesión', 'Debe iniciar sesión antes de continuar', 'Más opciones', 'Proyector de Opinómetro', 'Proyector de Preguntas'])
    .then(result => {
      this.textTranslate = result;
    });

    this.client = this.params.get('client');
    this.event = this.params.get('event');

    if (this.event.languages.length > 1) {
      this.isMultilanguages = true;
    }

    // close de listener where logout user
    events.subscribe('client:logout', () => {
      this.closeListener();
    });
  }

  ionViewDidEnter(){
    if (!this.auth.getUser().isAnonymous) {
      this.userProvider.getProfile(this.client, this.auth.getUser())
      .then((user) => {
        setTimeout(() => {
          this.isAnonymous = false;
          this.user = user;

          this.obsBadgeCatalog = this.eventProvider.getCatalogBadge(this.client, this.auth.getUser().uid).subscribe((data) => {
            this.badgeCatalogUser = data;
          });
        }, 300);
      })
      .catch(() => {
        this.navCtrl.push(UserEditPage, {origin: 'event-profile', user: this.auth.getUser(), client: this.client, blockBack: true, event: this.event});
      });
    } else {
      this.isAnonymous = this.auth.getUser().isAnonymous;
    }
  }

	editProfile() {
		this.navCtrl.push(UserEditPage, {origin: 'event-profile-edit', client: this.client, user: this.user, event: this.event});
	}

  viewFavorites() {
    this.navCtrl.push(EventFavoritePage, {client: this.client, event: this.event});
  }

  viewPays() {
    this.navCtrl.push(EventCatalogsPayment, {client: this.client, event: this.event, user: this.user});
  }

  viewReserves() {
    this.navCtrl.push(EventProfileReserves, {client: this.client, event: this.event});
  }

  viewCart() {
    if (!this.auth.getUser().isAnonymous) {
      this.navCtrl.push(EventCart, {client: this.client, event: this.event});
    } else {
        let modal = this.modalCtrl.create(LoginPage, {client: this.client, event: this.event});
        modal.present();

        let toast = this.toastCtrl.create({
          message: this.textTranslate["Debe iniciar sesión antes de continuar"],
          duration: 5000,
          position: 'top'
        });
        toast.present();
    }
  }

   moreOptions(survey) {
    let actionSheet = this.actionSheetCtrl.create({
      title: this.textTranslate['Más opciones'],
      buttons: [
        {
          icon: 'ios-pie-outline',
          text: this.textTranslate['Proyector de Opinómetro'],
          handler: () => {
            this.navCtrl.push(EventOpinometerView, {client: this.client, event: this.event});
          }
        },
        {
          icon: 'md-help',
          text: this.textTranslate['Proyector de Preguntas'],
          handler: () => {
            this.navCtrl.push(EventQuestionView, {client: this.client, event: this.event});
          }
        },
        {
          icon: 'close',
          text: this.textTranslate['Cancelar'],
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }

  changeLang() {
    let alert = this.alertCtrl.create();

    this.event.languages.forEach(lang => {
      let tmp: any = this.languages.transform(lang);
      alert.addInput({
        type: 'radio',
        label: this.textTranslate[tmp],
        value: lang,
        checked: this.translateProvider.getDefaultLang() == lang ? true : false
      });
    });

    alert.setTitle(this.textTranslate['Seleccione un idioma']);
    alert.addButton(this.textTranslate['Cancelar']);
    alert.addButton({
      text: this.textTranslate['Ok'],
      handler: data => {
        let loader = this.loading.create({
          content: this.textTranslate['Cargando'],
          dismissOnPageChange: true
        });
        loader.present();

        this.db.updateData('/Clients/' + this.client.url + '/Users/' + this.auth.getUser().uid + '/defaultLang', data)
        .then(() => {
          this.translateProvider.setDefaultLang(data);
          this.storage.set('defaultLanguage', data);
          setTimeout(() => {
            window.location.reload();
          }, 500);
        });
      }
    });

    alert.present();
  }

  logout(){
    let loader = this.loading.create({
      content: this.textTranslate['Cerrando sesión'],
      dismissOnPageChange: true
    });
    loader.present();

    this.events.publish('client:logout', true);

    setTimeout(() => {
  	  this.af.auth.logout().then(() => {
        this.navCtrl.pop();
      });
    }, 1000);
  }

  goRebus() {
    window.open(
      'https://www.appsiste.co',
      '_blank'
    );
  }

  ____rstClient() {
    this.storage.clear();
    window.location.reload();
  }

  closeListener() {
    if (this.obsBadgeCatalog) {
      console.log('Se eliminan los observables de Badge catalogs profile');
      this.obsBadgeCatalog.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}



// WEBPACK FOOTER //
// ./src/pages/event-profile/event-profile.ts